import React from 'react'

import SideBarInner from './sideBarInner'
import TitleInner from './titleInner'

import styles from './sideBarInnerWrapper.module.scss'

const SideBarInnerWrapper = props => {
  const { title } = props

  return (
    <div className={styles.sideBarInnerWrapper}>
      <SideBarInner>
        <div className={styles.container_titleInner}>
          <TitleInner title={title} />
        </div>
        {props.children}
      </SideBarInner>
    </div>
  )
}

export default React.memo(SideBarInnerWrapper)